"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _asyncApi = _interopRequireDefault(require("@ux/async-api"));
(0, _asyncApi.default)();